import { Util } from "src/utils/Util";
import { Address } from "../Address";
import { Phone } from "../Phone";
import { ClaimRegister } from "./ClaimRegister";
import { StatusTypeItem } from "./StatusTypeItem";
import { ClaimRegisterPicture } from "./ClaimRegisterPicture";
import { Coverage } from "../plan/Coverage";
import { Policy } from "../Policy";

export class ClaimAdjuster {

  /**
   * 
   */
  private _name: string;
  set name(_name: string) { this._name = _name };
  get name(): string { return this._name };

  /**
   * 
   */
  private _signature: string | undefined;
  set signature(_signature: string | undefined) { this._signature = _signature };
  get signature(): string | undefined { return this._signature };

  /**
   *
   */
  private _formId: string;
  set formId(_formId: string) { this._formId = _formId };
  get formId(): string { return this._formId };

  /**
   *
   */
  private _claimId: string;
  set claimId(_claimId: string) { this._claimId = _claimId };
  get claimId(): string { return this._claimId };

  /**
   *
   */
  private _claimNumber: string;
  set claimNumber(_claimNumber: string) { this._claimNumber = _claimNumber };
  get claimNumber(): string { return this._claimNumber };

  /**
   *
   */
  private _reportingName: string;
  set reportingName(_reportingName: string) { this._reportingName = _reportingName };
  get reportingName(): string { return this._reportingName };

  /**
   *
   */
  private _reportingPhone: Phone | undefined;
  set reportingPhone(_reportingPhone: Phone | undefined) { this._reportingPhone = _reportingPhone };
  get reportingPhone(): Phone | undefined { return this._reportingPhone };

  /**
   *
   */
  private _vehicleInvolved: string | undefined;
  set vehicleInvolved(_vehicleInvolved: string | undefined) { this._vehicleInvolved = _vehicleInvolved };
  get vehicleInvolved(): string | undefined { return this._vehicleInvolved };

  /**
   *
   */
  private _location: Address | undefined;
  set location(_location: Address | undefined) { this._location = _location };
  get location(): Address | undefined { return this._location };

  /**
   *
   */
  private _cabinFacts: string;
  set cabinFacts(_cabinFacts: string) { this._cabinFacts = _cabinFacts };
  get cabinFacts(): string { return this._cabinFacts };

  /**
   *
   */
  private _peopleFacts: string;
  set peopleFacts(_peopleFacts: string) { this._peopleFacts = _peopleFacts };
  get peopleFacts(): string { return this._peopleFacts };

  /**
   *
   */
  private _clousure: string;
  set clousure(_clousure: string) { this._clousure = _clousure };
  get clousure(): string { return this._clousure };

  /**
   *
   */
  private _date: Date | undefined;
  set date(_date: Date | undefined) { this._date = _date };
  get date(): Date | undefined { return this._date };

  /**
   *
   */
  private _completed: boolean;
  set completed(_completed: boolean) { this._completed = _completed };
  get completed(): boolean { return this._completed };

  /** 
   * 
   */
  private _isFirstForm: boolean;
  set isFirstForm(_isFirstForm: boolean) { this._isFirstForm = _isFirstForm };
  get isFirstForm(): boolean { return this._isFirstForm };

  /**
   *
   */
  private _claimPeople: ClaimRegister[];
  set claimPeople(_claimPeople: ClaimRegister[]) { this._claimPeople = _claimPeople };
  get claimPeople(): ClaimRegister[] { return this._claimPeople };

	/**
	 * 
	 */
	private _claimType: StatusTypeItem;
	set claimType(_claimType: StatusTypeItem) { this._claimType = _claimType };
	get claimType(): StatusTypeItem { return this._claimType };

  /**
   *
   */
  private _cause: StatusTypeItem | undefined;
  set cause(_cause: StatusTypeItem | undefined) { this._cause = _cause };
  get cause(): StatusTypeItem | undefined { return this._cause };

  /**
   *
   */
  private _liability: StatusTypeItem | undefined;
  set liability(_liability: StatusTypeItem | undefined) { this._liability = _liability };
  get liability(): StatusTypeItem | undefined { return this._liability };
  /**
   *
   */
  private _reason: StatusTypeItem | undefined;
  set reason(_reason: StatusTypeItem | undefined) { this._reason = _reason };
  get reason(): StatusTypeItem | undefined { return this._reason };

  /**
   *
   */
  private _referencePictures: ClaimRegisterPicture[];
  set referencePictures(_referencePictures: ClaimRegisterPicture[]) { this._referencePictures = _referencePictures };
  get referencePictures(): ClaimRegisterPicture[] { return this._referencePictures };

  /**
   *
   */
  private _duaPicture: ClaimRegisterPicture[];
  set duaPicture(_duaPicture: ClaimRegisterPicture[]) { this._duaPicture = _duaPicture };
  get duaPicture(): ClaimRegisterPicture[] { return this._duaPicture };

  /**
   *
   */
  private _coverages: Coverage[];
  set coverages(_coverages: Coverage[]) { this._coverages = _coverages };
  get coverages(): Coverage[] { return this._coverages };

  /**
   *
   */
  private _declarationSignature: string | undefined;
  set declarationSignature(_declarationSignature: string | undefined) { this._declarationSignature = _declarationSignature };
  get declarationSignature(): string | undefined { return this._declarationSignature };

  /**
   *
   */
  private _policy: Policy | undefined;
  set policy(_policy: Policy | undefined) { this._policy = _policy };
  get policy(): Policy | undefined { return this._policy };

  /**
   * 
   */
  private _isFormStarted: boolean;
  set isFormStarted(_isFormStarted: boolean) { this._isFormStarted = _isFormStarted };
  get isFormStarted(): boolean { return this._isFormStarted };

  constructor(_name: string, _formId: string, _claimId: string, _claimNumber: string, _reportingName: string, _cabinFacts: string, _type: StatusTypeItem) {
    this._name = _name;
    this._reportingName = _reportingName;
    this._cabinFacts = _cabinFacts;
    this._formId = _formId;
    this._isFirstForm = false;
    this._claimId = _claimId;
    this._claimNumber = _claimNumber;
    this._claimType = _type;
    this._completed = false;
    this._claimPeople = [];
    
    this._peopleFacts = '';
    this._clousure = '';
    this._referencePictures = [];
    this._duaPicture = [];
    this._coverages = [];
    this._isFormStarted = false;
  }

  /**
   * 
   */
  public setDeclarations(_peopleFacts?: string, _cause?: StatusTypeItem, _liability?: StatusTypeItem, _signature?: string): void {
    if (_peopleFacts) {
      this._peopleFacts = _peopleFacts;
    }

    if (_cause) {
      this._cause = _cause;
    }

    if (_liability) {
      this._liability = _liability;
    }

    if (_signature) {
      this._declarationSignature = _signature;
    }
  }

	/**
	 * 
	 */
	public updateClaimPerson(claimPerson: ClaimRegister, index?: number): void {
		if (this._claimPeople.length > 0) {
			if (claimPerson.person?.id) {
				for(let p of this._claimPeople) {
					if (p.person && p.person.id === claimPerson.person.id) {
						p = claimPerson;
						break;
					}
				}
			} else if (!!index) {
				this._claimPeople[index] = claimPerson;
			} else {
        this._claimPeople[this._claimPeople.length - 1] = claimPerson;
      }
		}
	};

	/**
	 * 
	 */
	public deleteClaimPerson(index: number): void {
		if (this._claimPeople[index].personType.id !== Util.STATUS_CODE.CLAIMS_PERSON_TYPES.INSURED)
			this._claimPeople.splice(index, 1);
	}

	/**
	 * 
	 * @param claimPerson 
	 * @returns 
	 */
	public addClaimPeople(claimPerson: ClaimRegister): void {
		if (!claimPerson.claimId) {
			claimPerson.claimId = this._claimPeople[0].claimId;
			claimPerson.formId = this._claimPeople[0].formId;
		}

		this._claimPeople.push(claimPerson);
	}

  /**
   * 
   */
  public setClousure(_clousure?: string, _reason?: StatusTypeItem): void {
    if (_clousure)
      this._clousure = _clousure;

    if (_reason)
      this._reason = _reason;
    else 
      this._reason = undefined;
  }

  /**
   * 
   */
  public getNaPersonName(): string {
    return `${this._claimPeople[0].person?.name!} ${this._claimPeople[0].person?.lastName!} ${this._claimPeople[0].person?.secondLastName!}`;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehicleBrand(): string {
    return `${Util.TRANSFORM.TEXT.firstLetterUpperCase(this._claimPeople[0].vehicle?.brand?.name!)}`;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehicleModel(): string {
    return `${Util.TRANSFORM.TEXT.firstLetterUpperCase(this._claimPeople[0].vehicle?.model?.name!)}`;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehicleYear(): string {
    return `${this._claimPeople[0].vehicle?.year?.value}`;
  }

  /**
   * 
   * @returns 
   */
  public isNewVehicle(): boolean {
    const vehicleYear = this._claimPeople[0].vehicle?.year?.value;

    if (vehicleYear) {
      const currentYear = new Date().getFullYear();
      const difference = currentYear - vehicleYear;
      
      if (difference <= 2)
        return true;
    }

    return false;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehicleColor(): string {
    return `${this._claimPeople[0].vehicleColor?.name ? this._claimPeople[0].vehicleColor?.name : ''}`;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehicleVin(): string {
    return `${this._claimPeople[0].vehicle?.vin}`;
  }

  /**
   * 
   * @returns 
   */
  public getNaVehiclePlates(): string {
    return `${this._claimPeople[0].vehicle?.plate}`;
  }

	/**
	 * 
	 * @returns 
	 */
	public hasNaVehicleValue(): boolean {
		if (this._claimPeople[0].vehicle?.comercialValue === undefined || this._claimPeople[0].vehicle?.comercialValue === null)
			return false;
		return this._claimPeople[0].vehicle?.comercialValue >= 0;
	}

	/**
	 * 
	 * @returns 
	 */
	public getNaVehicleValue(): string {
		if (this._claimPeople[0].vehicle?.comercialValue !== undefined)
			return `${this._claimPeople[0].vehicle?.comercialValue >= 0 ? this._claimPeople[0].vehicle?.comercialValue : '--'}`;
		else
			return '--';
	}
}